// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3xT0Y","paramInput":"JobSimulator_paramInput__O6Qn1","input":"JobSimulator_input__kC4-2"};